class IngredientSpotlightCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.ingredient-spotlight__track');
    this.list = this.querySelector('.ingredient-spotlight__list');
    this.items = Array.from(this.querySelectorAll('.ingredient-spotlight__item'));
    this.dots = Array.from(this.querySelectorAll('[data-ingredient-spotlight-dot]'));
    this.prevButton = this.querySelector('.ingredient-spotlight__arrow--prev');
    this.nextButton = this.querySelector('.ingredient-spotlight__arrow--next');

    if (!this.track || !this.list || this.items.length === 0) return;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.scrollToIndex(index));
    });

    if (this.prevButton) this.prevButton.addEventListener('click', () => this.step(-1));
    if (this.nextButton) this.nextButton.addEventListener('click', () => this.step(1));

    this.track.addEventListener('scroll', this.debounce(this.updateControls.bind(this), 100));
    window.addEventListener('resize', this.debounce(this.updateControls.bind(this), 150));

    this.updateControls();
    this.initFlipCards();
  }

  initFlipCards() {
    this.querySelectorAll('[data-flip-trigger]').forEach((button) => {
      button.addEventListener('click', () => {
        const card = button.closest('.ingredient-spotlight__card');
        if (!card) return;
        const flipped = card.classList.toggle('is-flipped');
        card.querySelectorAll('[data-flip-trigger]').forEach((btn) => {
          btn.setAttribute('aria-expanded', flipped ? 'true' : 'false');
          btn.tabIndex = (btn.dataset.flipTrigger === 'back') === flipped ? 0 : -1;
        });
      });
    });
  }

  debounce(fn, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = window.setTimeout(() => fn(...args), wait);
    };
  }

  currentIndex() {
    if (!this.items.length) return 0;
    const itemWidth = this.items[0].getBoundingClientRect().width + this.gap();
    return Math.round(this.track.scrollLeft / itemWidth);
  }

  gap() {
    return parseFloat(getComputedStyle(this.list).columnGap || getComputedStyle(this.list).gap || '0');
  }

  scrollToIndex(index) {
    const clamped = Math.max(0, Math.min(index, this.items.length - 1));
    const item = this.items[clamped];
    if (!item) return;
    this.track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
  }

  step(direction) {
    this.scrollToIndex(this.currentIndex() + direction);
  }

  updateControls() {
    const current = this.currentIndex();

    this.dots.forEach((dot, index) => {
      const active = index === current;
      dot.classList.toggle('ingredient-spotlight__dot--active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });

    if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 0;
    if (this.nextButton) {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
    }
  }
}

customElements.define('ingredient-spotlight-carousel', IngredientSpotlightCarousel);
